var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgReportGroup = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_0_21)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.08333 5.66667C7.3078 5.66612 7.53015 5.71002 7.73755 5.79586C7.94496 5.88169 8.13332 6.00774 8.29175 6.16675L10.8332 8.70825C10.9923 8.86668 11.1183 9.05504 11.2041 9.26245C11.29 9.46985 11.3339 9.6922 11.3333 9.91667V14.1667C11.3333 14.5424 11.1841 14.9027 10.9184 15.1684C10.6527 15.4341 10.2924 15.5833 9.91667 15.5833H2.83333C2.45761 15.5833 2.09728 15.4341 1.8316 15.1684C1.56592 14.9027 1.41667 14.5424 1.41667 14.1667V7.08333C1.41667 6.70761 1.56592 6.34728 1.8316 6.0816C2.09728 5.81592 2.45761 5.66667 2.83333 5.66667H7.08333Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.08333 5.66667V9.20833C7.08333 9.39619 7.15796 9.57636 7.2908 9.7092C7.42364 9.84204 7.60381 9.91667 7.79167 9.91667H11.3333",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M5.66667 2.83333C5.66667 2.45761 5.81592 2.09728 6.0816 1.8316C6.34728 1.56592 6.70761 1.41667 7.08333 1.41667H11.3333C11.5578 1.41612 11.7801 1.46002 11.9876 1.54586C12.195 1.63169 12.3833 1.75774 12.5417 1.91675L15.0833 4.45825C15.2423 4.61668 15.3683 4.80504 15.4541 5.01245C15.54 5.21985 15.5839 5.4422 15.5833 5.66667V9.91667C15.5833 10.2924 15.4341 10.6527 15.1684 10.9184C14.9027 11.1841 14.5424 11.3333 14.1667 11.3333",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M11.3333 1.41667V4.95833C11.3333 5.14619 11.408 5.32636 11.5408 5.4592C11.6736 5.59204 11.8538 5.66667 12.0417 5.66667H15.5833",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_21"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgReportGroup);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/report-group.418ede3571dbb87a60c3e1b2ed7a0452.svg";